import { api, unwrap, type APIResponse } from "./client";

// Mirrors app/routers/musiconhold.py MohOut.
export interface Moh {
  musiconhold_id: number;
  name: string;
  type: string;
  file_name: string;
  description: string;
  length: number;
  is_ready: boolean;
  text_message: string | null;
}

export interface MohInput {
  name: string;
  type: string;
  file_name: string;
  description: string;
  length: number;
  text_message: string | null;
}

export async function listMoh(): Promise<Moh[]> {
  const resp = await api.get<APIResponse<Moh[]>>("/musiconhold/");
  return unwrap(resp.data);
}

export async function createMoh(body: MohInput): Promise<number> {
  const resp = await api.post<APIResponse<{ musiconhold_id: number }>>("/musiconhold/", body);
  return unwrap(resp.data).musiconhold_id;
}

export async function updateMoh(id: number, body: MohInput): Promise<void> {
  await api.put(`/musiconhold/${id}`, body);
}

export async function deleteMoh(id: number): Promise<void> {
  await api.delete(`/musiconhold/${id}`);
}
